import React from 'react';
import './About.css';

const education = [
  { degree: 'BS Information Technology', school: 'La Consolacion College – Bacolod', period: '2013 – 2017' },
  { degree: 'BS Marine Transportation', school: 'John B. Lacson Colleges Foundation', period: '2011 – 2012' },
];

const awards = [
  { title: 'Impact Hackathon — Top 15', year: '2019' },
  { title: '1st Place, PSITS Quiz Bowl — LCCB', year: '2017' },
  { title: 'Best Capstone Programmer', year: '2016 – 2017' },
  { title: 'PSITS Club Vice-President', year: '2016 – 2017' },
  { title: 'Complete WordPress & Theme Development', year: 'Certificate' },
];

const About = () => (
  <section id="about" className="about wrap">
    <div className="about-bio">
      <span className="eyebrow">[04] — About</span>
      <h2 className="display about-title">
        Based in{' '}<br />Bacolod.{' '}<br /><span className="outline-text">Remote</span>{' '}<br />everywhere.
      </h2>
      <div className="about-text">
        <p>
          I’m a <strong>full stack developer</strong> who builds web applications, mobile apps
          and the APIs that connect them.
        </p>
        <p>
          Since 2017 I’ve shipped production software for agencies, startups and my own
          products: Laravel and Node.js backends, Angular, React and Vue frontends,
          cross-platform mobile apps with Flutter and Ionic, and custom WordPress plugins.
          My own app, Transactfy, is a Flutter point-of-sale system live on Google Play.
        </p>
        <p>
          I’ve worked remotely with teams in the UK, Germany and the Philippines, and I care
          about code that is correct, maintainable and actually solves the business problem.
        </p>
      </div>
    </div>

    <div className="about-records">
      <div className="record">
        <h3 className="record-title eyebrow">Education</h3>
        <ul className="record-list">
          {education.map((edu) => (
            <li key={edu.degree} className="record-row">
              <span className="record-main">
                <span className="record-name">{edu.degree}</span>
                <span className="record-sub">{edu.school}</span>
              </span>
              <span className="record-year mono">{edu.period}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="record">
        <h3 className="record-title eyebrow">Recognition</h3>
        <ul className="record-list">
          {awards.map((award) => (
            <li key={award.title} className="record-row">
              <span className="record-name">{award.title}</span>
              <span className="record-year mono">{award.year}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default About;
